module.exports = __webpack_public_path__ + "static/media/alice1.a1ddcfe5.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/alice1.JPG
// module id = 52
// module chunks = 0